"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classes_1 = require("../classes");
class WhenAnyAction {
    constructor(tasks) {
        this.actionType = classes_1.ActionType.WhenAny;
        this.compoundActions = tasks.map((t) => t.actionObj);
    }
}
exports.WhenAnyAction = WhenAnyAction;
//# sourceMappingURL=whenanyaction.js.map